(function () {
    'use strict';

    angular
        .module('bcmModule')
        .controller('biaResponsibilityListModalController', Controller);

    Controller.$inject = ['$scope', '$state', 'biaResponsibilityService'];

    function Controller($scope, $state, biaResponsibilityService) {

        if (_.isUndefined($scope.ctrlCtxt)) $scope.ctrlCtxt = {};

        $scope.ctrlCtxt.groupedByPriorityPromise
              .then(function () {
                  $scope.ratedButNotPrioritizedSortableOptions = {
                      animation: 0,
                      forceFallback: true,
                      dragClass: "js-sortable",
                      sort: false,
                      group: 'priorityLevel',
                      onAdd: function (evt) {
                          if (!evt.model) return;
                          evt.model.PriorityLevelID = null;
                          evt.model.PriorityLevel = null;
                          $scope.updateBIAResponsibility(evt.model)
                                .then(function (updatedBiaResp) {
                                    evt.model.PriorityLevel = updatedBiaResp.PriorityLevel;
                                });
                      }
                  };

                  $scope.ratedBIARespsByPriority = _.map($scope.ratedBIARespsByPriority, function (byPriority) {
                      byPriority.sortableOptions = {
                          animation: 0,
                          forceFallback: true,
                          dragClass: "js-sortable",
                          sort: false,
                          group: 'priorityLevel',
                          onAdd: function (evt) {
                              if (!evt.model) return;
                              evt.model.PriorityLevelID = byPriority.PriorityLevel.LookupAttributeValueID;
                              evt.model.PriorityLevel = _.clone(byPriority.PriorityLevel);
                              $scope.updateBIAResponsibility(evt.model)
                                    .then(function (updatedBiaResp) {
                                        evt.model.PriorityLevel = _.clone(updatedBiaResp.PriorityLevel);
                                    });
                          }
                      };

                      return byPriority;
                  });
              })

        // Update BIA Responsiblity
        $scope.updateBIAResponsibility = function (respToUpd) {

            return biaResponsibilityService
                    .updateBIAResponsibility(respToUpd.BIAProfileID,
                                             respToUpd.BIAResponsibilityID,
                                             respToUpd);
        };
    
    }
})();